
export const saveValues = (key, value, persist = false) => {
    if (persist) {
        localStorage.setItem(key, value)
    } else {
        sessionStorage.setItem(key, value)
    }

}

export const retrieveValues = (key, defaultValue=false) => {
    const persist = localStorage.getItem("persistme")
    if (persist == 'false') {
        return sessionStorage.getItem(key)|| defaultValue
    } else {
        return localStorage.getItem(key)|| defaultValue
    }
}

export const removeValues = key => {
    const persist = localStorage.getItem("persistme")
    if (persist == 'false') {
        sessionStorage.removeItem(key)
    } else {
        localStorage.removeItem(key)
    }
}

export const clearStore = () => {
    const persist = localStorage.getItem("persistme")
    if (persist == 'false') {
        sessionStorage.clear()
    } else {
        localStorage.clear()
    }
}

